/**
 * Loops through a list of items.
 *
 * Compatible with a NodeList.
 *
 * https://toddmotto.com/ditch-the-array-foreach-call-nodelist-hack/#recommendations
 *
 * @param array
 * @param callback
 * @param scope
 */
export function forEach(array, callback, scope) {
  for (var i = 0; i < array.length; i++) {
    callback.call(scope, array[i], i); // Passes back stuff we need.
  }
}